import api from './api.service';

function unwrap<T>(res: any): T {
  const data = res?.data ?? res;
  return (data?.data ?? data) as T;
}

export interface SupplierDebitNoteLineDTO {
  id: string;
  description?: string;
  quantity: number;
  unit_rate: number;
  amount: number;
  tax_amount?: number;
  reason?: string;
}

export interface SupplierDebitNoteDTO {
  id: string;
  debit_note_number: string;
  debit_note_date: string;
  supplier_id: string;
  purchase_return_id?: string;
  supplier_invoice_id?: string;
  subtotal: number;
  tax_amount: number;
  total_amount: number;
  currency: string;
  debit_note_type?: string;
  status: string;
  journal_voucher_id?: string;
  remarks?: string;
  supplier?: { id: string; supplier_name?: string };
  purchaseReturn?: { id: string; return_number?: string };
  supplierInvoice?: { id: string; invoice_number?: string };
  lines?: SupplierDebitNoteLineDTO[];
}

export interface DebitNoteFilters {
  supplier_id?: string;
  status?: string;
  date_from?: string;
  date_to?: string;
}

export const supplierDebitNoteService = {
  list: (filters?: DebitNoteFilters) =>
    api.get('/finance/debit-notes', { params: filters }).then(unwrap<SupplierDebitNoteDTO[]>),

  findById: (id: string) =>
    api.get(`/finance/debit-notes/${id}`).then(unwrap<SupplierDebitNoteDTO>),

  createFromPurchaseReturn: (purchaseReturnId: string) =>
    api.post('/finance/debit-notes/from-purchase-return', { purchase_return_id: purchaseReturnId }).then(unwrap<SupplierDebitNoteDTO>),

  create: (body: {
    debit_note_date: string;
    supplier_id: string;
    supplier_invoice_id?: string;
    debit_note_type?: string;
    remarks?: string;
    lines: Array<{ description?: string; amount: number; tax_amount?: number; reason?: string }>;
  }) =>
    api.post('/finance/debit-notes', body).then(unwrap<SupplierDebitNoteDTO>),

  submit: (id: string) =>
    api.post(`/finance/debit-notes/${id}/submit`).then(unwrap<SupplierDebitNoteDTO>),

  approve: (id: string) =>
    api.post(`/finance/debit-notes/${id}/approve`).then(unwrap<SupplierDebitNoteDTO>),

  post: (id: string) =>
    api.post(`/finance/debit-notes/${id}/post`).then(unwrap<SupplierDebitNoteDTO>),

  cancel: (id: string) =>
    api.post(`/finance/debit-notes/${id}/cancel`).then(unwrap<SupplierDebitNoteDTO>),
};
